export default __webpack_public_path__ + "images/inmarket-logo.23852063541d5141b06286289cab0651.png";